import { ReusableModal } from "ui/molecules/modal/ReusableModal";
import { useImperativeHandle, useState } from "react";
import React from "react";
import { AssessmentReportFillTemplate } from "../templates/AssessmentReportFillTemplate";
import { SubmittedFormModel } from "app/services/api/types/forms/models/SubmittedFormModel";

interface Props {}
export interface AssessmentReportFillModalRef {
  open: ({ entry }: { entry: SubmittedFormModel }) => void;
}
export const AssessmentReportFillModal = React.forwardRef<
  AssessmentReportFillModalRef,
  Props
>((_, ref) => {
  const [show, setShow] = useState(false);
  const [entry, setEntry] = useState<SubmittedFormModel | undefined>(undefined);

  useImperativeHandle(ref, () => ({
    open: ({ entry }) => {
      setEntry(entry);
      setShow(true);
    },
  }));

  return (
    <ReusableModal
      fullScreen
      isVisible={show}
      onClose={() => setShow(false)}
      title="Edit Assessment"
      noBackgroundClose
    >
      <AssessmentReportFillTemplate
        entry={entry}
        onSubmit={() => setShow(false)}
      />
    </ReusableModal>
  );
});
